import { apiRequest } from "api-client";
import apiEndpoints from "constants/endpoints";
import {
  GET_GAMES_ERROR,
  GET_GAMES_FINISH,
  GET_GAMES_START,
} from "store/actionTypes/game";

export const getGames = () => {
  return (dispatch) => {
    console.log("action get games");
    dispatch({
      type: GET_GAMES_START,
    });
    apiRequest.get(`${apiEndpoints.games}`)
      .then((data) => {
        dispatch({
          type: GET_GAMES_FINISH,
          payload: data,
        });
      })
      .catch((err) => {
        dispatch({
          type: GET_GAMES_ERROR,
          payload: err,
        });
      });
  };
};
